import React from "react";
import { ClapSpinner } from "react-spinners-kit";
import { convertLogbookDateTimezone, makeFirstLetterCapital } from "../../../../../utility/utility";

let LogBookLogsArea = (props) => {
  const log = props.logbookLog ? props.logbookLog : {};
  return props.isLogbookLogsAreas ? (
    <div className="loader_btn_block">
      {" "}
      <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />{" "}
    </div>
  ) : (
    <>
      <main className="app-content add_area_modal">
        <div className="appcontent_Inner">
          <div className="add_info_block">
            <div className="inspections">
              <div className="left_list ">
                <h2 className="h2_title ">Logbook Log Details</h2>
              </div>
              <div className="inspection_content_block">
                <div className="left_list">
                  <h4 style={{ color: "#850037", fontWeight: "bold" }}>
                    Logbook Name :{" "}
                  </h4>
                </div>
                <div className="right_list">
                  <h4>{log.name ? makeFirstLetterCapital(log.logbook.name) : "-"}</h4>
                </div>
              </div>

              <div className="inspection_content_block">
                <div className="left_list">
                  <h4 style={{ color: "#850037", fontWeight: "bold" }}>
                    Reviewed by :{" "}
                  </h4>
                </div>
                <div className="right_list">
                  <h4>{log.name ? makeFirstLetterCapital(log.name) : "-"}</h4>
                </div>
              </div>

              {/* <div className="inspection_content_block">
                <div className="left_list">
                  <h4 style={{ color: "#850037", fontWeight: "bold" }}>
                    Logbook ID :{" "}
                  </h4>
                </div>
                <div className="right_list">
                  <h4>{log?.id}</h4>
                </div>
              </div> */}

              <div className="inspection_content_block">
                <div className="left_list">
                  <h4 style={{ color: "#850037", fontWeight: "bold" }}>
                    Review Status :{" "}
                  </h4>
                </div>
                <div className="right_list">
                  <h4>{makeFirstLetterCapital(log.status)}</h4>
                </div>
              </div>

              <div className="inspection_content_block">
                <div className="left_list">
                  <h4 style={{ color: "#850037", fontWeight: "bold" }}>
                    Scheduled Date :{" "}
                  </h4>
                </div>
                <div className="right_list">
                  <h4>
                    {convertLogbookDateTimezone(log?.created_at, log.user?.account_timezone) }
                  </h4>
                </div>
              </div>
              <div className="inspection_content_block">
                <div className="left_list">
                  <h4 style={{ color: "#850037", fontWeight: "bold" }}>
                    Reviewed Date :{" "}
                  </h4>
                </div>
                <div className="right_list">
                  <h4>
                    {convertLogbookDateTimezone(log?.updated_at, log.user?.account_timezone) }
                  </h4>
                </div>
              </div>
           
              <div className="inspection_content_block">
                <div className="left_list">
                  <h4 style={{ color: "#850037", fontWeight: "bold" }}>
                    Comments :{" "}
                  </h4>
                </div>
                <div className="right_list">
                  <h4>
                    {makeFirstLetterCapital(log.comment) }
                  </h4>
                </div>
              </div>

              <div className="inspection_content_block">
                <div className="left_list">
                  <h4 style={{ color: "#850037", fontWeight: "bold" }}>
                    Initial
                  </h4>
                </div>
                {/* <div className="right_list">
                  <img src={log.initial_url?.public_url} alt='initial' />
                </div> */}
              </div>

              <div className="inspection_content_block">
              <div >
                <img src={log.initial_url?.small} alt='initial' />
                </div>
              </div>

            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default LogBookLogsArea;
